import { render, staticRenderFns } from "./ServiceListItemCard.vue?vue&type=template&id=494b82c0&scoped=true"
import script from "./ServiceListItemCard.vue?vue&type=script&lang=js"
export * from "./ServiceListItemCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494b82c0",
  null
  
)

export default component.exports